import { render, staticRenderFns } from "./demographic-form-1071.vue?vue&type=template&id=19ade8a0&"
import script from "./demographic-form-1071.vue?vue&type=script&lang=ts&"
export * from "./demographic-form-1071.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports